// extracted by mini-css-extract-plugin
export default {"main":"DetailMap_main__nDVZS","box_map":"DetailMap_box_map__ZNmy9","flareAnimation":"DetailMap_flareAnimation__V-5PT","shine":"DetailMap_shine__ZnUZw"};